import Loading from 'components/Loading';
import NewDesign from 'components/NewDesign';
import { TooltipReactTooltip } from 'components/Tooltip';
import { isDefine } from 'helpers';
import { get } from 'lodash';
import React, { useState } from 'react';

const propTypes = {};

/**
 *
 * @param {Object} props
 * @param {string} props.status
 * @param {{ idTooltip, rejectReason, failureReason }} props.statusOptions
 * @returns
 */
const BadgeStatus = ({ status, statusOptions }) => {
  //! State
  const { idTooltip, rejectReason, failureReason } = statusOptions || {};

  const [colors] = useState({
    PENDING: 'primary',
    RUNNING: 'primary',
    APPROVED: 'success',
    RELEASED: 'success',
    COMPLETED: 'success',
    REJECTED: 'danger',
    ERROR: 'danger',
    FAILED: 'danger',
    ROLLBACK: 'danger',
    PAUSED: 'danger',
    RELEASING: 'warning',
    ROLLING_BACK: 'warning',
  });

  //! Function

  //! Render
  const renderRejectReason = () => {
    if (!rejectReason) {
      return null;
    }

    if (isDefine(idTooltip)) {
      return (
        <div>
          <TooltipReactTooltip
            idTarget={idTooltip}
            messageToolTip={<div style={{ maxWidth: 300 }}>{rejectReason}</div>}
          >
            <NewDesign.Typography className='color-danger-v2 is-hover mt-1' component='p'>
              Reject reason
            </NewDesign.Typography>
          </TooltipReactTooltip>
        </div>
      );
    }

    return (
      <NewDesign.Alert color='danger' className='mb-0 mt-2 p-2'>
        Reject reason: {rejectReason}
      </NewDesign.Alert>
    );
  };

  const renderFailedReason = () => {
    if (!failureReason) {
      return null;
    }

    if (isDefine(idTooltip)) {
      return (
        <div>
          <TooltipReactTooltip idTarget={idTooltip} messageToolTip={failureReason}>
            <NewDesign.Typography className='color-danger-v2 is-hover mt-1' component='p'>
              Failure reason
            </NewDesign.Typography>
          </TooltipReactTooltip>
        </div>
      );
    }

    return (
      <NewDesign.Alert color='danger' className='p-2 mt-2 w-100 mb-0'>
        Failure reason: {failureReason}
      </NewDesign.Alert>
    );
  };

  return (
    <div className='component:BadgeStatus'>
      <NewDesign.Badge useV2 color={get(colors, status) || ''}>
        {status === 'RUNNING' && (
          <Loading
            color='var(--color-primary-v2)'
            style={{ display: 'inline-block', marginRight: 6 }}
          />
        )}
        {status}
      </NewDesign.Badge>

      {renderRejectReason()}
      {renderFailedReason()}
    </div>
  );
};

BadgeStatus.propTypes = propTypes;
export default BadgeStatus;
